import { SalesOrderItemType } from '../constants/sales-order-item-type.js';
/** Line types that ship from the order's own warehouse stock, so submit reserves them and acceptance picks them; Sample and Promo ship physically at zero revenue. */
export const STOCKED_LINE_TYPES = new Set([
    SalesOrderItemType.SALE,
    SalesOrderItemType.MISC_SALE,
    SalesOrderItemType.KIT,
    SalesOrderItemType.SAMPLE,
    SalesOrderItemType.PROMO,
]);
export function isStockedLineType(typeId) {
    return STOCKED_LINE_TYPES.has(typeId);
}
//# sourceMappingURL=stocked-line-types.js.map